import React, { useState, useEffect, useCallback } from 'react';
import TabPanel from 'devextreme-react/tab-panel';
import { useAuth } from '../../contexts/auth';
import notify from 'devextreme/ui/notify';
import { Button } from 'devextreme-react/button';
import { useNavigate } from 'react-router-dom';
import {getAPIReportData, adminGetSettings, adminUpdateSettings} from '../../api/api'
import { SelectBox } from 'devextreme-react/select-box';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import { HSESafetyMetrics,HSESafetyMetricsAPI, HSESafetyStrategy, HSEProduction,
  HSEFlaring, HSEHazard, HSESpill, HSEEnvMetric, HSEWater, HSEReportData, HSEEmissions, } from '../../components';
import './hse.scss';

export default function HSE() {
  const navigate = useNavigate();
  const { user, refreshSession } = useAuth();
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [yearsList, setYearsList] = useState([]);
  const [currentYear, setCurrentYear] = useState(null);
  const [settingsHSEYears, setSettingsHSEYears] = useState([]);
  const [reportTabs, setReportTabs] = useState();

  const onDataSuccess = useCallback((data) => {
    let rt = [
      {
        title: 'Safety Metrics (Standard)',
        icon: "fas fa-calculator",
        children: (<HSESafetyMetrics data={data} year={currentYear}/>)
      },
      {
        title: 'Safety Metrics (API Financial)',
        icon: "fas fa-calculator",
        children: (<HSESafetyMetricsAPI data={data} year={currentYear}/>)
      },
      {
        title: 'Safety Strategy',
        icon: "fas fa-file-invoice",
        children: (<HSESafetyStrategy data={data} year={currentYear}/>)
      },
      {
        title: 'GHG and Flaring',
        icon: "fab fa-gripfire",
        children: (<HSEFlaring data={data} year={currentYear}/>)
      },
      {
        title: 'Spill KPIs',
        icon: "fas fa-fill-drip",
        children: (<HSESpill data={data} year={currentYear}/>)
      },
      {
        title: 'Water Use',
        icon: "fas fa-hand-holding-water",
        children: (<HSEWater data={data} year={currentYear}/>)
      },
      {
        title: 'Additional Env Metrics',
        icon: "fab fa-envira",
        children: (<HSEEnvMetric data={data} year={currentYear}/>)
      },
      {
        title: 'Production',
        icon: "fas fa-industry",
        children: (<HSEProduction data={data} year={currentYear}/>)
      },
      {
        title: 'Report Data',
        icon: "fas fa-database",
        children: (<HSEReportData data={data} year={currentYear}/>)
      }
    ]
    const emissionIdentifiers = [
      "154", "146", "147", "148", "149", "150", "151", "152"
    ];
    if (data.some(e => emissionIdentifiers.includes(e["Identifier"]))) {
      rt.splice(4, 0, {
        title: 'Emission Details',
        icon: "fas fa-smog",
        children: (<HSEEmissions data={data} year={currentYear}/>)
      });
    }
    let hazardfields = [
      "15", "18", "28", "31", "16", "19", "29", "32",
    ]
    var fd = data.filter((e) => {return hazardfields.includes(e["Identifier"]) && e["Details"].includes("Please enter top")});
    if (fd.length) {
      rt.push({
        title: 'Hazard Analysis',
        icon: "fas fa-user-injured",
        children: (<HSEHazard data={data} year={"2023"}/>)
      })
    }
    setReportTabs(rt)
    setLoading(false);
  }, [setReportTabs, currentYear])

  const onSettingsSuccess = useCallback((data) => {
    for (var i=0; i<data.length; i++) {
      if (data[i]["setting"] === "hse_published_years") {
        if (user.signInUserSession) {
          let groups = user.signInUserSession.idToken.payload['cognito:groups']
          if (groups && (!groups.includes('admin'))) {
            if (data[i]["value"].length) {
              setYearsList([...data[i]["value"]]);
            } else {
              notify("No HSE reports are available at this time. Please try again later.", 'warning', 5000);
              navigate("/home");
            }
          } else {
            const cy = new Date().getFullYear();
            var yl = []
            for (var j=2023; j<cy; j++) {
              yl.push(j.toString())
            }
            setYearsList(yl);
          }
        }

        var max = null;
        if (data[i]["value"].length) {
          max = data[i]["value"].reduce((max, c) => c > max ? c : max)
          setSettingsHSEYears(data[i]["value"]);
        } else {
          const cy = new Date().getFullYear();
          max = (cy-1).toString();
          setSettingsHSEYears([]);
        }
        if (!currentYear) {
          setCurrentYear(max);
        }
      }
    }
  }, [setSettingsHSEYears, currentYear, setCurrentYear, setYearsList, user, navigate])

  const onSettingsUpdateSuccess = useCallback((data) => {
    for (var i=0; i<data.length; i++) {
      if (data[i]["setting"] === "hse_published_years") {
        setSettingsHSEYears(data[i]["value"]);
        notify("Report published succesfully.", 'success', 5000);
        if (data[i]["value"].includes(currentYear)) {
          setLoading(false)
        } else {
          const max = data[i]["value"].reduce((max, c) => c > max ? c : max)
          setCurrentYear(max);
        }
      }
    }
  }, [setSettingsHSEYears, currentYear, setCurrentYear])

  const onError = useCallback((error) => {
    if (error.status === 401) {
      refreshSession();
    } else {
      notify("An error has occured. Please try again later.", 'error', 2000);
      setLoading(false);
      console.log(error);
    }
  }, [refreshSession]);

  useEffect(() => {
    if (user.signInUserSession) {
      let groups = user.signInUserSession.idToken.payload['cognito:groups']
      var has_perm=false;
      if (groups) {
        for (var i=0; i<groups.length; i++) {
          if (groups[i].includes("hsero")) {
            has_perm=true;
          }
          if (groups[i]==='admin') {
            has_perm=true;
            setIsAdmin(true);
          }
        }
      }

      if (!has_perm) {
        notify("Insufficient permissions. Please contact the system administrator.", 'error', 5000);
        navigate('/home');
        return
      }
      adminGetSettings(user, onSettingsSuccess, onError);
    }
  }, [user, navigate, onSettingsSuccess, onError]);

  function TabPanelItem({ data }) {
    return <div className="tabpanel-item px-3">{data.children}</div>;
  }

  const onYearSelected = useCallback((e) => {
    setCurrentYear(e.value);
  }, [setCurrentYear])

  const onPublishYear = useCallback((e) => {
    var yl = [...settingsHSEYears, currentYear]
    yl.sort();
    setLoading(true);
    adminUpdateSettings(user, {hse_published_years: yl}, onSettingsUpdateSuccess, onError)

  }, [currentYear, settingsHSEYears, onSettingsUpdateSuccess, onError, user])

  const onUnpublishYear = useCallback((e) => {
    var yl = []
    for (var i=0; i<settingsHSEYears.length; i++) {
      if (settingsHSEYears[i] !== currentYear) {
        yl.push(settingsHSEYears[i])
      }
    }
    yl.sort();
    setLoading(true);
    adminUpdateSettings(user, {hse_published_years: yl}, onSettingsUpdateSuccess, onError)
  }, [currentYear, settingsHSEYears, onSettingsUpdateSuccess, onError, user])

  useEffect(() => {
    if (currentYear) {
      setLoading(true);
      getAPIReportData('/reports/hse/'+currentYear, user, {}, onDataSuccess, onError);
    }
  }, [currentYear, user, onDataSuccess, onError]);


  if(!loading) {
  return (
    <React.Fragment>
      <div className='content-block d-flex flex-row justify-content-between'>
      <h2>Health, Safety & Environmental Survey - {currentYear}</h2>
      <div className='d-flex flex-row'>
      {isAdmin && <Button
        text="Company Data"
        stylingMode="outlined"
        type="default"
        onClick={() => {navigate("/hsedata")}}
      />}

      </div>
      </div>
      <hr className="mt-0 mb-5"></hr>
      {yearsList.length &&
        <div className='content-block d-flex flex-row justify-content-between'>
          <div className='d-flex flex-column'>
            {isAdmin && <h5 className="mt-3"> Choose the reporting year</h5>}
            <SelectBox
                value={currentYear}
                dataSource={yearsList}
                showDropDownButton={true}
                activeStateEnabled={true}
                onValueChanged={onYearSelected}
                label={"Reporting year"}
                labelMode="floating"
            >
            </SelectBox>
          </div>
          {isAdmin && currentYear && <Button
            text={settingsHSEYears.includes(currentYear)?`Un-publish year ${currentYear}`:`Publish year ${currentYear}`}
            stylingMode="normal"
            type="danger"
            onClick={settingsHSEYears.includes(currentYear)?onUnpublishYear:onPublishYear}
          />}
        </div>

      }
      {currentYear && <div className={'content-block'}>

        <div className={'dx-card responsive-paddings'}>
          <TabPanel
            width="100%"
            height={"auto"}
            animationEnabled={false}
            swipeEnabled={true}
            dataSource={reportTabs}
            tabsPosition={'left'}
            stylingMode={'secondary'}
            iconPosition={'left'}
            itemComponent={TabPanelItem}
          />
        </div>
      </div>}
    </React.Fragment>
  )
} else {
  return (
    <div className="d-flex flex-row justify-content-center align-items-center mt-5 pt-5">
        <LoadIndicator
            id="large-indicator"
            height={60}
            width={60}
        />
    </div>
  )
}

}
